const TimeSegment = ({ value, label, isFirst }: { value: number; label: string; isFirst?: boolean }) => (
  <div className={`flex flex-col items-center px-4 py-4 relative ${isFirst ? 'border-r border-orange-200' : ''}`}>
    <span className='text-[32px] font-medium text-orange-800 leading-none'>{value}</span>
    <span className='text-13 opacity-[0.7] md:text-base font-normal text-orange10 mt-1'>{label}</span>
  </div>
)

export default TimeSegment
